// Samples a representative average color from an image's center crop.
// Used to give each app's connector line a colour derived from its cover
// art instead of the icon's placeholder background. Center-crops to dodge
// transparent edges and circular-mask anti-aliasing in covers.

const SAMPLE_SIZE = 64;
const CENTER_FRACTION = 0.5;

export function sampleAverageColor(img: HTMLImageElement): string | null {
  const w = img.naturalWidth;
  const h = img.naturalHeight;
  if (!w || !h) return null;

  const canvas = document.createElement('canvas');
  canvas.width = SAMPLE_SIZE;
  canvas.height = SAMPLE_SIZE;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return null;

  const cropW = w * CENTER_FRACTION;
  const cropH = h * CENTER_FRACTION;
  const cropX = (w - cropW) / 2;
  const cropY = (h - cropH) / 2;

  try {
    ctx.drawImage(img, cropX, cropY, cropW, cropH, 0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
    const { data } = ctx.getImageData(0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
    let r = 0, g = 0, b = 0, n = 0;
    for (let i = 0; i < data.length; i += 4) {
      const a = data[i + 3] ?? 0;
      if (a < 16) continue;
      r += data[i] ?? 0;
      g += data[i + 1] ?? 0;
      b += data[i + 2] ?? 0;
      n += 1;
    }
    if (n === 0) return null;
    const ri = Math.round(r / n);
    const gi = Math.round(g / n);
    const bi = Math.round(b / n);
    return `#${ri.toString(16).padStart(2, '0')}${gi.toString(16).padStart(2, '0')}${bi.toString(16).padStart(2, '0')}`;
  } catch {
    return null;
  }
}
